var IMAGE_RESIZE = {
    CROP: 'fill',
    FIT: 'fit',
    MIN: 'min',
    MAX: 'max',
};
export default IMAGE_RESIZE;
//# sourceMappingURL=cubeType.js.map